<template>
  <div class="">
    <div class="">
      <b-button pill v-b-toggle.create-language variant="primary">ساخت زبان</b-button>
      <b-collapse id="create-language" class="mt-2">
        <LanguageForm :submit-function="createLanguage" class="col-lg-12 my-4"/>
      </b-collapse>
    </div>
    <table-items :items="languages"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import tableItems from "../../components/dashboard/Language/tableItems";
import LanguageForm from "../../components/dashboard/Language/LanguageForm";

export default {
  name: "Languages",
  components: {tableItems, LanguageForm},
  computed: {
    ...mapGetters({
      languages: 'Language/getLanguages'
    })
  },
  methods: {
    ...mapActions({
      createLanguage: "Language/createLanguage"
    })
  },
  mounted() {
    this.$store.dispatch('Language/getLanguages')
  }
}
</script>

<style scoped>

</style>